import { __rest, __read, __assign } from '../../node_modules/tslib/tslib.es6.esm.js';
import React__default, { useLayoutEffect } from 'react';
import { useDropdownMenu } from '@restart/ui';
import classNames from 'classnames';

var DropdownMenu = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var _b = __read(useDropdownMenu({
        flip: true,
        offset: [0, 8],
    }), 2), menuProps = _b[0], _c = _b[1], show = _c.show, popper = _c.popper;
    useLayoutEffect(function () {
        var _a;
        if (show)
            (_a = popper === null || popper === void 0 ? void 0 : popper.update) === null || _a === void 0 ? void 0 : _a.call(popper);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);
    return (React__default.createElement("div", __assign({}, props, menuProps, { className: classNames('nv-contextual-menu', { 'nv-contextual-menu--show': show }) }), children));
};

export { DropdownMenu as default };
//# sourceMappingURL=DropdownMenu.esm.js.map
